import {Reducer} from 'redux'
import type {BreadcrumbAction, BreadcrumbState} from '../../types/types'

const initialBCState: BreadcrumbState = {};

const breadcrumbReducer: Reducer<BreadcrumbState, BreadcrumbAction> = function(state = initialBCState, action) {
  if(action.type === 'BREADCRUMB_UPDATE') {
    return {routeSegments: action.routeSegments};
  } else {
    return state;
  }
};

export default breadcrumbReducer;
